(function () {
  const target = document.currentScript.dataset.target;
  const section = document.getElementById(target);
  const article = section.querySelector('.article');
  const articleContent = Array.from(section.querySelector('.article__content').children)

  articleContent.forEach(articleContentItem => {

    if (articleContentItem.getBoundingClientRect().top < window.innerHeight) {
      articleContentItem.classList.add('article-content--animate');
    }

    const articleContentObserverCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {

          entry.target.classList.add('article-content--animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const articleContentObserver = new IntersectionObserver(articleContentObserverCallback, {
      root: null,
      rootMargin: '0px',
      threshold: 1,
    }
    );

    articleContentObserver.observe(articleContentItem);
  })
})();